import React from 'react';
import { NavLink } from 'react-router-dom';
import { GiHiveMind } from 'react-icons/gi';
import { FaCloud, FaArrowRight } from 'react-icons/fa';
import { MdOutlineIntegrationInstructions } from 'react-icons/md';
import './Homepage.css';
import img1 from '../Components/Assets/About1.jpeg';

export const Homepage = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content container">
          <div className="hero-text">
            <span className="badge">Software Services & Consulting</span>
            <h1>Digitally Transformed Human Experiences</h1>
            <p>
              Critical decisions are comparable to a one-way door — they cannot be
              reversed once made. We are your trusted partner in software services and
              consulting, helping your business navigate the digital landscape with confidence.
            </p>
            <div className="hero-actions">
              <NavLink to="/contact" className="btn btn-primary">
                Get Started <FaArrowRight />
              </NavLink>
              <NavLink to="/about" className="btn btn-outline">
                Learn More
              </NavLink>
            </div>
          </div>
          <div className="hero-image">
            <img src={img1} alt="Digital transformation" />
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="badge">What We Do</span>
            <h2>Our Core Services</h2>
            <p>
              We deliver solutions that redefine industry standards through expert 
              consulting, modern engineering, and strategic thinking.
            </p>
          </div>
          <div className="grid-3">
            <div className="card service-card">
              <div className="service-icon">
                <GiHiveMind />
              </div>
              <h3>Artificial Intelligence</h3>
              <p>Leverage AI and machine learning to automate processes and gain insights that drive smarter business decisions.</p>
            </div>
            <div className="card service-card">
              <div className="service-icon">
                <FaCloud />
              </div>
              <h3>Cloud & DevOps</h3>
              <p>Migrate to the cloud and streamline your development pipeline with modern DevOps practices for faster delivery.</p>
            </div>
            <div className="card service-card">
              <div className="service-icon">
                <MdOutlineIntegrationInstructions />
              </div>
              <h3>Software Development</h3>
              <p>Build durable, scalable software solutions tailored to your business needs using modern technologies.</p>
            </div>
          </div>
          <div className="section-cta">
            <NavLink to="/service" className="btn btn-outline">
              View All Services <FaArrowRight />
            </NavLink>
          </div>
        </div>
      </section>

      {/* Value Props */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="badge">Why 1WayDoor</span>
            <h2>Trusted Industry Expertise</h2>
            <p>
              For over 16 years, our founders have partnered with companies in highly 
              regulated and specialized industries to solve their most complex business problems.
            </p>
          </div>
          <div className="grid-3">
            <div className="value-card">
              <div className="value-number">01</div>
              <h3>Design</h3>
              <p>We design digital products that adhere to your strategic roadmap using design thinking tools to enhance the value for your users.</p>
            </div>
            <div className="value-card">
              <div className="value-number">02</div>
              <h3>Strategy</h3>
              <p>A winning strategy maximizes business value. We analyze your objectives to create a strategic roadmap for digital transformation.</p>
            </div>
            <div className="value-card">
              <div className="value-number">03</div>
              <h3>Engineering</h3>
              <p>We build durable, modern software that delivers on your digital transformation objectives — scalable, flexible, and secure.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Clients Banner */}
      <section className="section section-alt clients-banner">
        <div className="container">
          <div className="section-header">
            <span className="badge">Trusted By</span>
            <h2>Partnering with Industry Leaders</h2>
          </div>
          <div className="home-clients-row">
            <div className="home-client-item">
              <span className="home-client-name">Deloitte</span>
            </div>
            <div className="home-client-divider"></div>
            <div className="home-client-item">
              <span className="home-client-name">HP / Mphasis</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>Partner with us to unlock your full potential and achieve your digital ambitions.</p>
            <NavLink to="/contact" className="btn btn-white">
              Schedule a Consultation <FaArrowRight />
            </NavLink>
          </div>
        </div>
      </section>
    </div>
  );
};
